<template>
  <v-container>
    <v-row
      class="text-center"
      wrap
    >
      <v-col cols="12">
        <v-card
          elevation=0
          class="mx-auto"
          max-width="500"
        >
          <v-card-title class="title text-md-center justify-space-between">
            <v-row>
              <v-col>
                <span>{{ currentTitle }}</span>
              </v-col>
            </v-row>
            <v-avatar
              color="teal lighten-2"
              class="subheading white--text"
              size="24"
              v-text="step"
            ></v-avatar>
          </v-card-title>

          <v-window v-model="step">

            <v-window-item :value="1">
              <v-card-text>
                <h3 class="title font-weight-light mb-2">
                  Divorcing can be difficult and challenging.
                </h3>
                <span>Book a strategy session for some guidance and direction to get you started on your separation.</span>
                <v-row>
                  <v-col cols="6">
                    <v-btn class="book-btn btn-initial-session-colour" large dark @click="selectProduct(PRODUCT_STRATEGY_INITIAL)">
                      <ul class="unstyled">
                        <li><span class="book-btn-title headline">Initial Session</span></li>
                        <li><span>1 Hour</span></li>
                        <li><span class="price">$ 164</span></li>
                      </ul>
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn class="book-btn" large dark @click="selectProduct(PRODUCT_STRATEGY_SUBSEQUENT)">
                      <ul class="unstyled">
                        <li><span class="book-btn-title headline">Subsequent<br>Session</span></li>
                        <li><span>45 Minutes</span></li>
                        <li><span class="price">$ 149</span></li>
                        <!-- <li><span class="subprice">per session</span></li> -->
                      </ul>
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn large dark color="book-btn" @click="selectProduct(PRODUCT_STRATEGY_3PACK)">
                      <ul class="unstyled">
                        <li><span class="book-btn-title headline">3 Pack Sessions</span></li>
                        <li><span>3 x 45 Minutes</span></li>
                        <li><span class="price">$ 399</span></li>
                        <li><span class="subprice">( $133 per session )</span></li>
                      </ul>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
              <v-card-text>
                <span class="grey--text text--darken-1">
                  Please enter your details so we can arrange the session
                </span>
                <v-form ref="nameForm" v-model="nameFormValid">
                  <v-text-field
                    color="teal"
                    v-model="firstName"
                    label="First name*"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    color="teal"
                    v-model="lastName"
                    label="Last name*"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    color="teal"
                    v-model="email"
                    label="Email*"
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
              <v-card-text>
                <span class="grey--text text--darken-1">
                  Please enter the best contact number where you wish to receive the call
                </span>
                <v-form ref="contactForm" v-model="contactFormValid">
                  <v-text-field
                    v-model="phone"
                    outlined
                    label="Phone number*"
                    :rules="[rules.required]"
                    color="teal"
                    hint="Please enter the best contact number where you wish to receive the call"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    color="teal"
                    v-model="preference"
                    :rules="[rules.required]"
                    label="What's the best day and time to contact you?*"
                  ></v-textarea>
                </v-form>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="4">
              <v-card-text>
                <v-textarea
                  color="teal"
                  outlined
                  v-model="comment"
                  label="What would you like addressed during your session?"
                ></v-textarea>
                <span class="grey--text text--darken-1">
                  Please describe any specific part of your divorce that you would like to talk about.
                </span>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="5">
              <div class="pa-3 text-xs-center">
                <h3 class="title font-weight-light mb-2">
                  {{orderTitle}}. Please enter your credit card information below to book your session.
                </h3>
                <span>Your credit card will be charged: {{totalPrice}}<br>We never store your card number or CVC number</span>
                <div ref="card"></div>
                <span class="red--text">{{paymentError}}</span>
              </div>
            </v-window-item>

            <v-window-item :value="6">
              <v-col>
                <v-icon x-large dark color="teal">check_circle</v-icon>
              </v-col>
              <div class="pa-3 text-xs-center">
                <h3 class="title font-weight-light mb-2">
                  Thank you, {{firstName}}!<br>We will email you shortly with a list of suggested times using your preferences for your confirmation.
                </h3>
              </div>
            </v-window-item>
          </v-window>

          <v-divider></v-divider>

          <v-card-actions v-if="step > 1 && step < 6">
            <v-btn
              :disabled="step === 1"
              text
              @click="step--"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :loading="isProcessing"
              color="teal"
              dark
              depressed
              @click="next"
            >
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
// test: pk_test_tT1xwbJZpid9L9OUUBBkMBfx
// prod: pk_live_xNpUYYjuxIFBmjsZ6sVRiy0q
import axios from 'axios'
const dev = false

const productIdStrategySessionInitial = dev ? 'price_1LRDC2L0ooabIMOTI5bHTbrI' : 'price_1LREBBL0ooabIMOTa6HQ5XC2'
const productIdStrategySessionSubsequent = dev ? 'price_1H18ODL0ooabIMOTLrK7svlx' : 'price_1H18PgL0ooabIMOTkVhcBDbV'
const productId3StrategySessions = dev ? 'price_1H18OiL0ooabIMOT8XZhAmRp' : 'price_1H18P9L0ooabIMOTxJ7KR5Wk'
const stripeKey = dev ? 'pk_test_tT1xwbJZpid9L9OUUBBkMBfx' : 'pk_live_xNpUYYjuxIFBmjsZ6sVRiy0q'
const serverURL = dev ? 'localhost:6544' : 'api.limpidpay.com'
const appId = '475516db-5ca9-428f-8c65-5e2a35206872'

// eslint-disable-next-line
let stripe = Stripe(stripeKey)
const elements = stripe.elements()
let card

export default {
  data: () => ({
    PRODUCT_STRATEGY_INITIAL: 1,
    PRODUCT_STRATEGY_3PACK: 2,
    PRODUCT_STRATEGY_SUBSEQUENT: 3,
    step: 1,
    isProcessing: false,
    nameFormValid: false,
    contactFormValid: false,
    paymentError: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    comment: '',
    preference: '',
    productId: 0,
    rules: {
      required: value => !!value || 'Required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    }
  }),
  watch: {
    step (value) {
      console.log('value = ' + value)
      const that = this
      if (value === 5) {
        setTimeout(function () {
          card = elements.create('card', { hidePostalCode: true })
          card.mount(that.$refs.card)
          // Handle real-time validation errors from the card Element.
          card.addEventListener('change', function (event) {
            if (event.error) {
              that.paymentError = event.error.message
            } else {
              that.paymentError = ''
            }
          })
        }, 500)
      }
    }
  },

  created () {
    // card = elements.create('card', {hidePostalCode: true})
    // card.mount(this.$refs.card)
    // var that = this
    // // Handle real-time validation errors from the card Element.
    // card.addEventListener('change', function(event) {
    //   if (event.error) {
    //     that.paymentError = event.error.message
    //   } else {
    //     that.paymentError = ''
    //   }
    // })
  },

  computed: {
    totalPrice () {
      let price = 0
      switch (this.productId) {
        case this.PRODUCT_STRATEGY_INITIAL:
          price = '$ 164'
          break
        case this.PRODUCT_STRATEGY_3PACK:
          price = '$ 399'
          break
        case this.PRODUCT_STRATEGY_SUBSEQUENT:
          price = '$ 149'
          break
      }
      return price
    },
    orderTitle () {
      let title = ''
      switch (this.productId) {
        case this.PRODUCT_STRATEGY_INITIAL:
          title = `Your 1 Hour strategy session is ${this.totalPrice} and includes a follow-up email`
          break
        case this.PRODUCT_STRATEGY_3PACK:
          title = `Your three 45-minute strategy sessions are ${this.totalPrice} and include a follow-up email`
          break
        case this.PRODUCT_STRATEGY_SUBSEQUENT:
          title = `Your 45-minute session is ${this.totalPrice} and includes a follow-up email`
          break
      }
      return title
    },
    currentTitle () {
      switch (this.step) {
        case 1: return 'Strategy Session'
        case 2: return 'Contact Details'
        case 3: return 'Contact Number'
        case 4: return 'Other Info'
        case 5: return 'Payment'
        default: return 'Payment Successful'
      }
    }
  },

  methods: {
    stripeTokenHandler (token) {
      console.log('stripe token handler')
      console.log(token.id)
      console.log(token)
      const that = this
      let prodId = 0
      switch (this.productId) {
        case this.PRODUCT_STRATEGY_INITIAL:
          prodId = productIdStrategySessionInitial
          break
        case this.PRODUCT_STRATEGY_3PACK:
          prodId = productId3StrategySessions
          break
        case this.PRODUCT_STRATEGY_SUBSEQUENT:
          prodId = productIdStrategySessionSubsequent
          break
      }
      const payload = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        preference: this.preference,
        comment: this.comment,
        stripePriceId: prodId,
        token: token
      }
      axios({
        method: 'post',
        url: `//${serverURL}/v1/transactions/${appId}`,
        data: payload
      }).then((resp) => {
        console.log(resp)
        that.isProcessing = false
        that.step++
      }).catch((error) => {
        console.log(error)
        that.paymentError = error.message
        let errorReponse = { code: 0, title: 'Unkown API error', message: 'Unkown API error' }
        if (error.response && error.response.data && error.response.data.status === 'error') {
          errorReponse = error.response.data.error
        } else {
          errorReponse.title = error.message
          errorReponse.message = error.message
        }
        that.paymentError = errorReponse.message
        that.isProcessing = false
      })
    },
    purchase () {
      const that = this
      this.paymentError = ''
      this.isProcessing = true
      stripe.createToken(card).then(result => {
        if (result.error) {
          that.paymentError = result.error.message
          that.$forceUpdate()
          that.isProcessing = false
        } else {
          console.log(result)
          that.stripeTokenHandler(result.token)
        }
      })
    },
    validate () {
      if (this.step === 2) {
        if (this.$refs.nameForm.validate()) {
          this.step++
        }
      } else if (this.step === 3) {
        if (this.$refs.contactForm.validate()) {
          this.step++
        }
      } else if (this.step === 5) {
        this.purchase()
      } else {
        this.step++
      }
    },
    next () {
      this.validate()
    },
    previous () {

    },
    selectProduct (id) {
      this.productId = id
      this.step++
    }
  }
}
</script>

<style>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  margin-top: 15px;
  border-radius: 4px;
  border: 1px solid #5da198;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.title, .theme--light.v-sheet {
  color: rgb(35, 164, 154) !important;
}
.book-btn {
  background-color: rgb(35, 164, 154) !important;
  border-color: rgb(35, 164, 154) !important;
  height: 150px !important;
  padding: 10px !important;
  width: 100%;
}
.btn-initial-session-colour {
  background-color: rgb(37 59 122) !important;
  border-color: rgb(37 59 122) !important;
}

.book-btn-title {
  text-transform: none;
}
.unstyled {
  list-style: none;
  padding: 0 !important;
}
.price {
  display: block;
  margin: 12px;
  font-size: 2rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: "Roboto", sans-serif !important;
}
.subprice {
  font-style: italic;
}
</style>
